module.exports = __webpack_public_path__ + "static/media/Jeff Hendry_1612007254486.6e198551.jpg";